module.exports = __webpack_public_path__ + "img/icon_gold.d28934e7.png";